import _ from 'lodash';

import { IParentPlayerContact } from '../../../lib/types';

interface IOption {
  value: string;
  label: string;
}

// A parent's contact rows for one athlete. `otherContacts` is resolved per
// athlete, so grouping is what renders that roster once instead of once a row.
export interface IParentPlayerContactGroup {
  playerId: string;
  contacts: IParentPlayerContact[];
}

export function groupContactsByPlayer(contacts: IParentPlayerContact[]): IParentPlayerContactGroup[] {
  return _.map(_.groupBy(contacts, 'playerId'), (rows, playerId) => ({ playerId, contacts: rows }));
}

// Verified entries are the canonical options; an unverified current value is
// prepended as "(current)"; a trailing "" entry lets the parent unset the field.
export function buildOptions(verified: string[], current: string | undefined, format: (v: string) => string, noneLabel: string): IOption[] {
  const list: IOption[] = verified.map((v) => ({ value: v, label: format(v) }));
  const hasCurrent = current && verified.includes(current);
  if (current && !hasCurrent) list.unshift({ value: current, label: `${format(current)} (current)` });
  list.push({ value: '', label: noneLabel });
  return list;
}
